import React from 'react'
import PropTypes from 'prop-types'

import { List, ListItem } from 'components/List'
import Loader from 'components/Loader'
import { ContactType } from 'types'
import style from './style.module.scss'
import Toggle from 'sharedComponents/Toggle'
import { Link } from 'react-router-dom'

AddressList.propTypes = {
    isLoading: PropTypes.bool,
    addresses: PropTypes.arrayOf(PropTypes.shape(ContactType)),
    onDelete: PropTypes.func,
    onUpdate: PropTypes.func,
}

function AddressList(props) {
    const { addresses, isLoading, onDelete, onUpdate } = props

    if (isLoading) {
        return <Loader />
    }

    if (addresses.length === 0) {
        return <Empty>No address added</Empty>
    }

    return (

        <List className={style.wrapper} addDividers={false}>
            {addresses.map((address) => (
                <ListItem
                    key={address.id}
                    className={style.item}
                >
                    {address.address}, {address.city}
                    <div className={style.toggleWrapper}>
                        <div>
                            <Toggle
                                value={address.isEnabled}
                                name={address.id}
                                onChange={(val) => {
                                    onUpdate(address.id, { isEnabled: val.value })
                                }}
                                className={style.toggle}
                            />
                        </div>
                        {
                            (address.id !== -1 && !address.isEnabled) && (
                                <div style={{ width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} >
                            <Link
                                to={`/manage-address/delete/${address.id}/${address.address}`}
                                className={style.cancelOrder}
                                style={{ width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="20" height="20" strokeWidth="1.5" stroke="#019bd1" aria-hidden>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                </svg>
                            </Link>
                        </div>
                            )
                        }
                    </div>
                </ListItem>
            ))}
        </List>
    )
}

export default AddressList
